import { setClassNames } from '@components/tree-component';
import { createSlice } from '@reduxjs/toolkit';

export const toLowerCaseFirst1 = (str = '') => {
  return str && str.charAt(0).toLowerCase() + str && str.slice(1);
};

export const picklistSysNames = [
  'CheckRecurrenceType',
  'CheckPriority',
  'CostCenters',
  'WorkOrderSkills',
  'AreaHierarchy',
  'SiteStatus',
  'CodeOfConstruction',
  'SiteType',
  'Province',
  'CheckPriority',
  'WorkOrderPriority',
  'AssignableUsers',
  'WorkOrderStatus',
  'EquipmentCategory', // TODO
  'EquipmentType',
  'EquipmentSubType',
  'EquipmentStatus', // TODO
  'Service',
  'WorkOrderType',
  'Trade',
  'PhotoCategory',
  'DocumentCategory',
  'Condition',
  'EquipmentValveLocation', // Todo
  'PSVType',
  'Pressure', // TODO
  'Volume',
  'Temperature',
  'SmallMeasurement',
  'TradeSkills',
  'CounterReadingUnits',
  'StructureType',
  'WorkRequestStatus',
  'InspectionFrequency',
  'PipelineStatus', // TODO
  'Material',
  'Substance',
  'InternalProtection',
  'OperationsArea',
  'PipelineType',
  'EquipmentConnectionType',

  'PipelineCathodicProtection',
  'PipelineAssignedBatchingInterval',
  'PipelineAssignedPiggingInterval',
  'ExternalProtection',
  'PipelineReceiverType',
  'PipelineSenderType',
  'EquipmentCategoryTypeSubtype',
  'Capacity',
  'ConcentrationUnits',
  'LargeMeasurement',
  'TimeUnit',
  'FailureCriteria',
  'FlowRate',
  'CylinderType',
  'ConstructionMaterial',
  'GaugeBoardUOM',
  'EquipmentInsulationMaterial',
  'IncidentCategory',
  'HSEProactiveEffortType',
  'HSEFocusAreas',
  'HSEVendors',
  'FunctionalGroup',
  'Species',
  'WildlifeIncidentType',
  'IncidentStatus',
  'OrientationType',

  'CMLComponent',
  'CMLLocation',
  'UltrasonicTestingCMLSchedule',
  'SmallMeasurementAllowed',
  'PSVDischargesTo',
  'ANSIRating'
];
export const dropdownPicklistsNames = [
  'PSVDischargesTo',
  'ANSIRating',
  'SmallMeasurement',
  'SmallMeasurementAllowed',
  'PipelineCathodicProtection',
  'PipelineAssignedBatchingInterval',
  'PipelineAssignedPiggingInterval',
  'ExternalProtection',
  'InternalProtection', // dublicate
  'Material', //dublicate
  'OperationsArea', //dublicate
  'PipelineReceiverType',
  'PipelineSenderType',
  'PipelineType', //dublicate
  'EquipmentCategoryTypeSubtype',
  'EquipmentValveLocation', // dublicate
  'Capacity',
  'ConcentrationUnits',
  'LargeMeasurement',
  'TimeUnit',
  'FailureCriteria',
  'FlowRate',
  'Condition', //dublicate
  'SiteType', //dublicate
  'CylinderType',
  'ConstructionMaterial',
  'StructureType', //dublicate
  'GaugeBoardUOM',
  'EquipmentInsulationMaterial',
  // HSE
  'IncidentCategory',
  'HSEProactiveEffortType',
  'HSEFocusAreas',
  'HSEVendors',
  'FunctionalGroup',
  'Species',
  'WildlifeIncidentType',
  'IncidentStatus',
  'OrientationType',

  // UML
  'CMLComponent',
  'CMLLocation',
  // "OrientationType",
  'UltrasonicTestingCMLSchedule'
  // "ConstructionMaterial"
];
const initialState = {
  loading: false,
  picklistsMap: {},
  ...picklistSysNames.reduce((acc, curr) => {
    acc[`${toLowerCaseFirst1(curr)}${curr === 'AreaHierarchy' ? 'Tree' : ''}Data`] = [];
    return acc;
  }, {}),
  areaHierarchyData: {},
  areaHierarchyDataMap: {}
};

export const picklistsSlice = createSlice({
  name: 'picklists',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPicklists: (state, action) => {
      const arr = [];
      let picklistsMap = {};
      const { payload = {} } = action;
      const { areaHierarchyData = [] } = payload;
      const areaHierarchyTreeDataMap = areaHierarchyData
        .map(({ key, value, parentKey }) => ({ key, title: value, parentKey }))
        .reduce((acc, curr) => {
          acc[curr.key] = { ...curr, children: [] };
          return acc;
        }, {});

      for (const key in areaHierarchyTreeDataMap) {
        if (Object.hasOwnProperty.call(areaHierarchyTreeDataMap, key)) {
          const curr = areaHierarchyTreeDataMap[key];
          if (areaHierarchyTreeDataMap[curr.parentKey])
            areaHierarchyTreeDataMap[curr.parentKey].children.push(areaHierarchyTreeDataMap[key]);
        }
      }

      for (const key in areaHierarchyTreeDataMap) {
        if (Object.hasOwnProperty.call(areaHierarchyTreeDataMap, key)) {
          const curr = areaHierarchyTreeDataMap[key];
          if (!curr.parentKey) arr.push(curr);
        }
      }

      for (const key in payload) {
        if (
          Object.hasOwnProperty.call(payload, key) &&
          key !== 'areaHierarchyData' &&
          payload[key]
        ) {
          const data = (payload[key] || []).map(({ key, value }) => ({ key, value }));
          if (key === 'workOrderPriorityData') {
            let sort = (payload[key] || [])
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map(({ key, value }) => ({ key, value }));

            state[key] = sort;
          } else if (key === 'workOrderTypeData') {
            state[key] = (payload[key] || []).map(
              ({ key, value, availableForWO = false, availableForWR = false }) => ({
                key,
                value,
                availableForWO,
                availableForWR
              })
            );
          } else state[key] = data;
          for (const el of data) picklistsMap[el.key] = el;
        }
      }

      const areaHierarchyDataMap = areaHierarchyData?.reduce((acc, curr) => {
        acc[curr?.key] = curr?.value;
        return acc;
      }, {});
      state.areaHierarchyTreeData = setClassNames(arr);
      state.areaHierarchyData = areaHierarchyData;
      state.areaHierarchyDataMap = areaHierarchyDataMap;
      state.areaHierarchyTreeDataMap = areaHierarchyTreeDataMap;
      if (Object.keys(picklistsMap).length > 0) state.picklistsMap = picklistsMap;
    },

    setPicklistsNew: (state, action) => {
      // const arr = [];
      let picklistsMap = {};
      // const { payload = {} } = action;
      // const { areaHierarchyData = [] } = payload;

      const { pickLists, areaHierarchyDataMap, areaHierarchyTreeData, areaHierarchyTreeDataMap } =
        action.payload;

      for (const key in pickLists) {
        if (
          Object.hasOwnProperty.call(pickLists, key) &&
          key !== 'areaHierarchyData' &&
          pickLists[key]
        ) {
          let pickListKeyList = pickLists[key] || [];
          const data = pickListKeyList.map((x) => {
            let obj = {
              key: x?.key,
              value: x?.value
            };
            return key === 'smallMeasurementAllowedData'
              ? {
                  ...obj,
                  lookupValue: x?.lookupValue
                }
              : obj;
          });

          if (key === 'workOrderPriorityData') {
            let sort = pickListKeyList
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map(({ key, value }) => ({ key, value }));

            state[key] = sort;
          } else if (key === 'workOrderTypeData') {
            state[key] = pickListKeyList.map(
              ({ key, value, availableForWO = false, availableForWR = false }) => ({
                key,
                value,
                availableForWO,
                availableForWR
              })
            );
          } else state[key] = data;

          for (const el of data) picklistsMap[el.key] = el;
        }
      }

      // const areaHierarchyDataMap = areaHierarchyData?.reduce((acc, curr) => {
      //   acc[curr?.key] = curr?.value;
      //   return acc;
      // }, {});

      state.areaHierarchyTreeData = areaHierarchyTreeData;
      state.areaHierarchyData = pickLists?.areaHierarchyData;
      state.areaHierarchyDataMap = areaHierarchyDataMap;
      state.areaHierarchyTreeDataMap = areaHierarchyTreeDataMap;
      if (Object.keys(picklistsMap).length > 0) state.picklistsMap = picklistsMap;
    }
  }
});

const picklistsReducer = picklistsSlice.reducer;

export const picklistsActions = picklistsSlice.actions;
export default picklistsReducer;
